// type ResultTuple<T, E> = [T, E | null];
// export type ErrorTuple<T, E> = [T | null, E];

import type { IndexEntry, Status } from './types';

// export type OptTuple<T, E> = ResultTuple<T, E> | ErrorTuple<T, E>;

/* export function isErrorTuple<T, E>(tuple: OptTuple<T, E>): tuple is ErrorTuple<T, E> {
  return tuple[1] !== null;
} */

// The above offers some advantages over the below, but doesn't allow us to do type assertions
// after destructuring the tuple.
// We should probably use a single discriminated union type instead of a tuple.

export type OptTuple<T, E> = [T | null, E | null];

export function assertNever(x: never): never {
  throw new Error(`Unexpected object: ${JSON.stringify(x)}`);
}

export function assertNotNull<T>(value: T): asserts value is NonNullable<T> {
  if (value === null || value === undefined) {
    throw new Error('Value is null or undefined');
  }
}

const indexEntryEqual = (a: IndexEntry, b: IndexEntry) => {
  if (!a && !b) return true;
  if ((a && !b) || (!a && b)) return false;
  if (a.conflictStatus !== b.conflictStatus) return false;
  if (a.hash !== b.hash) return false;
  if (a.isOldHead !== b.isOldHead) return false;
  if (a.isStaged !== b.isStaged) return false;
  if (a.mtime !== b.mtime) return false;
  if (a.path !== b.path) return false;
  if (a.size !== b.size) return false;
  if (a.syncStatus?.sync !== b.syncStatus?.sync) return false;
  if (a.syncStatus?.syncError !== b.syncStatus?.syncError) return false;
  if (a.syncStatus?.state !== b.syncStatus?.state) return false;
  if (a.type !== b.type) return false;

  return true;
};

export const statusEqual = (a: Status, b: Status) => {
  if (!a && !b) return true;
  if ((a && !b) || (!a && b)) return false;
  if (a.path !== b.path) return false;
  if (a.type !== b.type) return false;
  if (a.workingDirMeta?.hash !== b.workingDirMeta?.hash) return false;
  if (a.workingDirMeta?.mtime !== b.workingDirMeta?.mtime) return false;
  if (a.workingDirMeta?.size !== b.workingDirMeta?.size) return false;
  if (!indexEntryEqual(a.head, b.head)) return false;
  if (!indexEntryEqual(a.oldHead, b.oldHead)) return false;
  if (!indexEntryEqual(a.staged, b.staged)) return false;
  if (!indexEntryEqual(a.conflict?.base, b.conflict?.base)) return false;
  if (!indexEntryEqual(a.conflict?.theirs, b.conflict?.theirs)) return false;

  return true;
};

/* 
export function isNotNull<T>(value: T | null): value is T {
  return value !== null;
} */
